import { createIcon } from './createIcon'

export const NewsFallbackIcon = createIcon({
  displayName: 'NewsFallbackIcon',
  viewBox: '0 0 110 110',
  path: [
    <path
      d="M100.833 0H9.16667C6.73552 0 4.40394 0.965771 2.68485 2.68485C0.965771 4.40394 0 6.73552 0 9.16667L0 100.833C0 103.264 0.965771 105.596 2.68485 107.315C4.40394 109.034 6.73552 110 9.16667 110H100.833C103.264 110 105.596 109.034 107.315 107.315C109.034 105.596 110 103.264 110 100.833V9.16667C110 6.73552 109.034 4.40394 107.315 2.68485C105.596 0.965771 103.264 0 100.833 0V0ZM100.833 98.5417C100.833 99.1495 100.592 99.7324 100.162 100.162C99.7324 100.592 99.1495 100.833 98.5417 100.833H11.4583C10.8505 100.833 10.2677 100.592 9.83788 100.162C9.40811 99.7324 9.16667 99.1495 9.16667 98.5417V11.4583C9.16667 10.8505 9.40811 10.2677 9.83788 9.83788C10.2677 9.40811 10.8505 9.16667 11.4583 9.16667H98.5417C98.8422 9.163 99.1402 9.22228 99.4165 9.34068C99.6928 9.45909 99.9412 9.634 100.146 9.85417C100.366 10.0588 100.541 10.3072 100.659 10.5835C100.778 10.8598 100.837 11.1578 100.833 11.4583V98.5417Z"
      fill="currentColor"
    />,
    <path
      d="M84.7915 18.3333H25.2082C22.044 18.3333 19.479 20.8984 19.479 24.0625V35.5208C19.479 38.685 22.044 41.25 25.2082 41.25H84.7915C87.9556 41.25 90.5207 38.685 90.5207 35.5208V24.0625C90.5207 20.8984 87.9556 18.3333 84.7915 18.3333Z"
      fill="currentColor"
    />,
    <path
      d="M48.1248 50.4167H22.9165C21.018 50.4167 19.479 51.9557 19.479 53.8542V56.1458C19.479 58.0443 21.018 59.5833 22.9165 59.5833H48.1248C50.0233 59.5833 51.5623 58.0443 51.5623 56.1458V53.8542C51.5623 51.9557 50.0233 50.4167 48.1248 50.4167Z"
      fill="currentColor"
    />,
    <path
      d="M48.1248 66.4583H22.9165C21.018 66.4583 19.479 67.9974 19.479 69.8958V72.1875C19.479 74.086 21.018 75.625 22.9165 75.625H48.1248C50.0233 75.625 51.5623 74.086 51.5623 72.1875V69.8958C51.5623 67.9974 50.0233 66.4583 48.1248 66.4583Z"
      fill="currentColor"
    />,
    <path
      d="M48.1248 82.5H22.9165C21.018 82.5 19.479 84.039 19.479 85.9375V88.2292C19.479 90.1276 21.018 91.6667 22.9165 91.6667H48.1248C50.0233 91.6667 51.5623 90.1276 51.5623 88.2292V85.9375C51.5623 84.039 50.0233 82.5 48.1248 82.5Z"
      fill="currentColor"
    />,
    <path
      d="M87.0833 82.5H61.875C59.9765 82.5 58.4375 84.039 58.4375 85.9375V88.2292C58.4375 90.1276 59.9765 91.6667 61.875 91.6667H87.0833C88.9818 91.6667 90.5208 90.1276 90.5208 88.2292V85.9375C90.5208 84.039 88.9818 82.5 87.0833 82.5Z"
      fill="currentColor"
    />,
    <path
      d="M87.0833 50.4167H61.875C59.9765 50.4167 58.4375 51.9557 58.4375 53.8542V56.1458C58.4375 58.0443 59.9765 59.5833 61.875 59.5833H87.0833C88.9818 59.5833 90.5208 58.0443 90.5208 56.1458V53.8542C90.5208 51.9557 88.9818 50.4167 87.0833 50.4167Z"
      fill="currentColor"
    />,
    <path
      d="M87.0833 66.4583H61.875C59.9765 66.4583 58.4375 67.9974 58.4375 69.8958V72.1875C58.4375 74.086 59.9765 75.625 61.875 75.625H87.0833C88.9818 75.625 90.5208 74.086 90.5208 72.1875V69.8958C90.5208 67.9974 88.9818 66.4583 87.0833 66.4583Z"
      fill="currentColor"
    />,
  ],
})
